import { shape, number, string } from 'prop-types';

export default shape({
    id: number.isRequired,
    imageUrl: string.isRequired,
    label: string.isRequired,
    level: number.isRequired,
    url: string.isRequired,
});
